// White-label branding.
// Demo deploys set REACT_APP_LOUNGE_NAME at Vercel build time.
// Prod (LCDP) leaves it unset and gets the default.
export const LOUNGE_NAME = process.env.REACT_APP_LOUNGE_NAME || 'La Casa del Puro';
